import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 班次列表
import { shiftList, shiftDel } from 'api/frequency';
import Edit from './modal';
export default {
  components: {
    Edit: Edit
  },
  data: function data() {
    return {
      is_all: false,
      form: {
        is_all: 1,
        name: ''
      },
      page: {
        page: 1,
        size: 20,
        total: 0
      },
      loading: false,
      tableData: []
    };
  },
  created: function created() {
    this.getShiftList();
  },
  methods: {
    // 分页相关
    handleSizeChange: function handleSizeChange(size) {
      this.page.size = size;
      this.getShiftList();
    },
    handleCurrentChange: function handleCurrentChange(currentPage) {
      this.page.page = currentPage;
      this.getShiftList();
    },
    // 获取数据
    getShiftList: function getShiftList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _this.form.is_all = _this.is_all ? 0 : 1;
              _context.next = 4;
              return shiftList(_objectSpread(_objectSpread({}, _this.form), _this.page));
            case 4:
              res = _context.sent;
              _this.loading = false;
              _this.tableData = res.data.result;
              _this.page.total = res.data.count;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 查询
    handlerQuery: function handlerQuery() {
      this.page.page = 1;
      this.getShiftList();
    },
    // 删除
    handleDelSetting: function handleDelSetting(row) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return shiftDel(row);
            case 2:
              _this2.getShiftList();
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // open create
    // 1 新建 2 编辑 0查看
    openEdit: function openEdit(str, info) {
      var _this3 = this;
      var $t = this.$t;
      var title = this.$t('876c0495');
      if (str === 1) title = this.$t('1361');
      if (str === 2) title = this.$t('1364');
      var msg = {
        title: title,
        type: str,
        info: info
      };
      if (str === 2) {
        // info.is_rest 0为false 1为true
        info.is_rest = !!Number(info.is_rest);
        this.$confirm($t('1727'), $t('1726'), {
          confirmButtonText: $t('131'),
          cancelButtonText: $t('66')
        }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$refs.edit.init(msg, info.is_default);
              case 1:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        })));
      } else {
        this.$refs.edit.init(msg);
      }
    }
  }
};